import { ConfirmationModal } from 'src/components/modals';
import modals from 'src/constants/modals';
import { dispatch } from 'src/redux/store';
import { selectTransactionOverview } from 'src/redux/slices/transaction';
import { noop } from 'lodash';
import { openModal } from 'src/redux/slices/modal';
import { useSelector } from 'react-redux';

const SelectRoleModal = () => {
	const transaction = useSelector(selectTransactionOverview);

	const handleConfirm = async () => {
		dispatch(
			openModal({ name: modals.confirmRelationship, payload: { side: transaction.isBuySide ? 'buy' : 'sell' } }),
		);
	};

	return (
		<ConfirmationModal
			sx={{ minWidth: '600px' }}
			modalName={modals.selectRole}
			handleClose={noop}
			withCancelButton={false}
			handleConfirm={handleConfirm}
			confirmText='Select Role'
			title='Select Your Role'
			description={
				<>
					Before continuing, please tell us your role in this transaction.
					<br />
					<br />
					This helps us tailor the questionnaires to your situation.
				</>
			}
		/>
	);
};

export default SelectRoleModal;
